import { render, staticRenderFns } from "./PauseScreen.vue?vue&type=template&id=1fa51a6c"
import script from "./PauseScreen.vue?vue&type=script&lang=js"
export * from "./PauseScreen.vue?vue&type=script&lang=js"
import style0 from "./PauseScreen.vue?vue&type=style&index=0&id=1fa51a6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports